/* VERGENT - cuadrícula tipo mosaico (masonry) para las tarjetas de producto.
   Cada foto conserva su tamaño original y se coloca debajo de la columna
   más baja, para que todo encaje sin huecos. No afecta a carruseles (.slider). */
(function () {
  var SELECTOR = 'ul.product-grid:not(.slider)';
  var pending = [];
  var rafId = null;

  function num(style, prop, fallback) {
    var v = parseFloat(style.getPropertyValue(prop));
    return isNaN(v) ? fallback : v;
  }

  function layout(grid) {
    if (!document.body.contains(grid)) return;
    var items = Array.prototype.filter.call(grid.children, function (el) {
      return el.tagName === 'LI' && getComputedStyle(el).display !== 'none';
    });
    if (!items.length) {
      grid.style.height = '';
      return;
    }
    var cs = getComputedStyle(grid);
    var cols = Math.max(1, Math.round(num(cs, '--vgt-cols', 2)));
    var rowGap = num(cs, '--vgt-gap', 16);
    var colGap = num(cs, '--vgt-colgap', 16);
    var colWidth = (grid.clientWidth - colGap * (cols - 1)) / cols;
    var heights = [];
    for (var i = 0; i < cols; i++) heights.push(0);

    items.forEach(function (item) {
      var col = 0;
      for (var c = 1; c < cols; c++) {
        if (heights[c] < heights[col] - 1) col = c;
      }
      item.style.left = col * (colWidth + colGap) + 'px';
      item.style.top = heights[col] + 'px';
      heights[col] += item.offsetHeight + rowGap;
    });

    grid.style.height = Math.max(0, Math.max.apply(null, heights) - rowGap) + 'px';
  }

  function schedule(grid) {
    if (pending.indexOf(grid) === -1) pending.push(grid);
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var list = pending.slice();
      pending = [];
      list.forEach(layout);
    });
  }

  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var grid = entry.target.classList.contains('vgt-masonry')
            ? entry.target
            : entry.target.closest('.vgt-masonry');
          if (grid) schedule(grid);
        });
      })
    : null;

  function attach(grid) {
    var isNew = !grid.classList.contains('vgt-masonry');
    if (isNew) {
      grid.classList.add('vgt-masonry');
      if (ro) ro.observe(grid);
    }
    Array.prototype.forEach.call(grid.children, function (li) {
      if (li.tagName !== 'LI' || li.dataset.vgtObserved) return;
      li.dataset.vgtObserved = '1';
      if (ro) ro.observe(li);
      li.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { schedule(grid); });
      });
    });
    if (isNew) layout(grid);
    schedule(grid);
  }

  function scan() {
    document.querySelectorAll(SELECTOR).forEach(attach);
  }

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('.vgt-masonry').forEach(schedule);
  });
  window.addEventListener('load', function () {
    document.querySelectorAll('.vgt-masonry').forEach(schedule);
  });

  new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();